import { render } from "./index.vue?vue&type=template&id=12ab31e8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=12ab31e8&lang=css"
import "./index.vue?vue&type=style&index=1&id=12ab31e8&scoped=true&lang=css"

import exportComponent from "F:\\2024-岗亭\\jxwx-carpark-duty\\jxwx-carpark-duty\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ab31e8"]])

export default __exports__